// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1cacn","legacyBtn":"MutateMid_legacyBtn__1-SnO"};